// Displaying timer post selecting the slots
import React from 'react';
import './styles.css';

const SlotTimer = ({ timeLeft }) => {
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  if (!timeLeft || timeLeft <= 0) return null;

  return (
    <div className="slotpayment-timer-box">
      <div className="slotpayment-timer-title">⏳ Slot Reserved</div>
      <div className="slotpayment-timer-time">{formatTime(timeLeft)}</div>
      <div className="slotpayment-timer-remaining">remaining</div>
    </div>
  );
};

export default SlotTimer;
